<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18"
				style="display: flex;flex-direction: row; align-items: center;justify-content: flex-end;">
				<el-button size="small" type="primary" icon="el-icon-delete" @click="handleClear"
					v-hasPermi="['system:sysOperLog:clear']">清空
				</el-button>
				<el-button size="small" type="primary" icon="el-icon-download" @click="handleExport"
					v-hasPermi="['system:sysOperLog:export']">导出</el-button>
				<el-dropdown style="margin-left:10px;">
					<el-button size="small" plain>更多操作<i class="el-icon-arrow-down el-icon--right"></i></el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item icon="el-icon-delete" @click="handleDels">批量删除</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-row>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
								v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
								style="width: 240px" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-select size="mini" style="width:100px" clearable v-model="quertInfo.objMap.status"
								placeholder="选择状态">
								<el-option label="成功" value="0"></el-option>
								<el-option label="失败" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								style="width: 160px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch"
								v-hasPermi="['system:sysOperLog:query']">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle"
					:height="tableHeight()" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40" align="left">
					</el-table-column>
					<el-table-column prop="id" label="序号" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="title" label="系统模块" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="businessType" label="操作类型" :show-overflow-tooltip="true"
						:formatter="formatBusinessType"></el-table-column>
					<el-table-column prop="requestMethod" label="请求方式" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="operName" label="操作人员" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="operIp" label="主机地址" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="operLocation" label="操作地点" width="300" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="status" label="操作状态" width="300" :formatter="formatStatus"></el-table-column>
					<el-table-column prop="createTime" label="操作时间" width="140"></el-table-column>
					<el-table-column label="操作" width="150" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-view" size="small" @click="handlePreview(scope.row)">预览
							</el-button>
							<el-button type="text" icon="el-icon-delete" size="small" @click="handleDel(scope.row.id)"
								v-hasPermi="['system:sysOperLog:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
						:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
			</el-card>
		</el-row>
		<el-dialog :visible.sync="openDialog" width="600px" :title="title">
			<el-form label-width="80px" ref="form" :model="form">
				<el-row>
					<el-col :span="12">
						<el-form-item label="模块标题" prop="title">
							{{form.title}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="业务类型" prop="businessType">
							{{formatBusinessType(form)}}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="方法名称" prop="method">
							{{form.method}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="请求方式" prop="requestMethod">
							{{form.requestMethod}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作类别" prop="operatorType">
							{{formatOperatorType(form)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作人员" prop="operName">
							{{form.operName}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="请求URL" prop="operUrl">
							{{form.operUrl}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="主机地址" prop="operIp">
							{{form.operIp}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作地点" prop="operLocation">
							{{form.operLocation}}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="请求参数" prop="operParam">
							{{form.operParam}}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="返回参数" prop="jsonResult">
							{{form.jsonResult}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio :label="0">启用</el-radio>
								<el-radio :label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="操作时间" prop="createTime">
							{{form.createTime}}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="错误消息" prop="errorMsg">
							{{form.errorMsg}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		sysOperLogList,
		clearSysOperLog,
		delSysOperLog,
		exportSysOperLog
	} from '@/api/system/sysOperLog.js'

	export default {
		name: "SysOperLog",
		computed: {},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				openDialog: false,
				ids: [],
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						search: ''
					}
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList()
			},
			async getList() {
				let _this = this;
				const {
					data: res
				} = await sysOperLogList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					title: undefined,
					businessType: undefined,
					method: undefined,
					requestMethod: undefined,
					operatorType: undefined,
					operName: undefined,
					deptName: undefined,
					operUrl: undefined,
					operIp: undefined,
					operLocation: undefined,
					operParam: undefined,
					jsonResult: undefined,
					status: undefined,
					errorMsg: undefined,
					createTime: undefined,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			handleClear: function() {
				let _this = this;
				_this.confirm({
					text: '确认清空所有数据吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						clearSysOperLog().then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});

			},
			handlePreview: function(row) {
				this.reset();
				this.title = "预览日志记录";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
			handleSelectionChange: function(val) {
				let _this = this;



			},
			handleDels: function() {

			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delSysOperLog(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '当前页',
					but2: '全部导出',
					type: '',
					data: _this.quertInfo,
					fn: function(param) {
						exportSysOperLog(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportSysOperLog().then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},
			formatBusinessType: function(row) {
				if (row.businessType == 0) {
					return '其它';
				} else if (row.businessType == 1) {
					return '新增';
				} else if (row.businessType == 2) {
					return '修改';
				} else if (row.businessType == 3) {
					return '删除';
				} else if (row.businessType == 4) {
					return '授权';
				} else if (row.businessType == 5) {
					return '导出';
				} else if (row.businessType == 6) {
					return '导入';
				} else if (row.businessType == 7) {
					return '强退';
				} else if (row.businessType == 8) {
					return '生成代码';
				} else {
					return '清空数据';
				}
			},
			formatOperatorType: function(row) {
				if (row.operatorType == 0) {
					return '其它';
				} else if (row.operatorType == 1) {
					return '后台用户';
				} else {
					return '手机端用户';
				}
			}
		}
	};
</script>
<style scoped="scoped">
</style>
